import axios from 'core/network/interceptor';
import { GetTempWorkersUrl, GetTempWorkerUrl, PostSyncTempWorkerUrl, PostTempWorkerUrl, PutArchiveTempWorkerUrl, PutTempWorkerUrl, GetExportUrl } from './constants';

interface createTempWorkerEntryVariables {
    data: any;
}

const CreateTempWorkerRequest = async ({data}: createTempWorkerEntryVariables) : Promise<any> => {
    const response = await axios.post(PostTempWorkerUrl, data);

    return response.data.temp_worker;
};

const GetTempWorkerRequest = async (tempWorkerId: number) => {
    const response = await axios.get(GetTempWorkerUrl(tempWorkerId));

    return response.data.temp_worker;
};

interface listTempWorkersEntryVariables {
    page: number;
    synced?: boolean,
    archived?: boolean,
    retours?: boolean,
}

const GetTempWorkersRequest = async (params: listTempWorkersEntryVariables) => {
    const response = await axios.get(GetTempWorkersUrl, { params });

    return response.data;
};

interface archiveTempWorkerEntryVariables {
    id: number;
    archive?: boolean;
}

const ArchiveTempWorkerRequest = async ({id, archive = true}: archiveTempWorkerEntryVariables) => {
    const response = await axios.put(PutArchiveTempWorkerUrl(id), {archive});

    return response.data;
};

const SyncTempWorkerRequest = async (tempWorkerId: number) => {
    const response = await axios.post(PostSyncTempWorkerUrl(tempWorkerId));

    return response.data;
};

interface updateTempWorkerEntryVariables {
    id: number;
    data: any;
}

const UpdateTempWorkerRequest = async ({id, data}: updateTempWorkerEntryVariables) : Promise<any> => {
    const response = await axios.put(PutTempWorkerUrl(id), data);

    return response.data.temp_worker;
};

const GetExportRequest = async (exportId: number) => {
  const response = await axios.get(GetExportUrl(exportId));

  return response.data;
};

export { CreateTempWorkerRequest, GetTempWorkerRequest, GetTempWorkersRequest, ArchiveTempWorkerRequest, SyncTempWorkerRequest, UpdateTempWorkerRequest, GetExportRequest };